var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',_vm._b({class:_vm.classes,style:(_vm.styles),on:{"click":_vm.onClick}},'i',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }